import { createContext as s, useContext as a } from "react";
import { a as o } from "../../../vanilla-CSAfDK5R.js";
const A = () => {
  const t = o(!1), e = o(null);
  return {
    idAtom: o("accordion"),
    sizeAtom: o("md"),
    typeAtom: o("default"),
    openAtom: t,
    onToggleAtom: e,
    toggleAtom: o(null, (n, r) => {
      var m;
      const c = !n(t);
      r(t, c), (m = n(e)) == null || m(c);
    })
  };
}, i = s(A()), p = () => a(i);
export {
  i as AccordionContext,
  A as createAccordionState,
  p as useAccordionStateAtoms
};
//# sourceMappingURL=index.js.map
